import OrderItemsAdd from 'components/pages/order/items-add';

export default class SubscriptionPlanEdit extends OrderItemsAdd {
  constructor(props, context) {
    super(props, context, {
      editSubscriptionPlan: true,
    });
  }
}
